const csrfTokenTag: HTMLMetaElement | null = document.head.querySelector('meta[name=csrf-token]');
const csrfToken = (csrfTokenTag && csrfTokenTag.content) || '';

export default csrfToken;
